import type { ReactNode } from "react";
import type { StatelessFlightSearchFormProperties } from "../../stateless";
import { InputCityDesktop } from "./input-city-desktop";
import { InputCityMobile } from "./input-city-mobile";
type InputCityLabels = {
  close: string;
  input: string;
};

export type InputCityProperties = {
  className?: string | undefined;
  selectedKey: string | undefined;
  setSelectedKey: (selectedKey: string | undefined) => void;
  labels: InputCityLabels;
  items?:
    | NonNullable<StatelessFlightSearchFormProperties["odQuery"]["data"]>
    | undefined;
  isRequired?: boolean | undefined;
  name?: string | undefined;
  error?: ReactNode | undefined;
  showValidation?: boolean | undefined;
};
export const InputCity = ({
  name,
  selectedKey,
  isRequired,
  ...properties
}: InputCityProperties) => (
  <>
    <InputCityDesktop
      className="max-md:hidden"
      isRequired={isRequired}
      selectedKey={selectedKey}
      {...properties}
    />
    <InputCityMobile
      className="md:hidden"
      isRequired={isRequired}
      selectedKey={selectedKey}
      {...properties}
    />
    <input
      className="hidden"
      name={name}
      readOnly
      required={isRequired}
      value={selectedKey ?? ""}
    />
  </>
);
